import { Navigate, useLocation, useParams } from 'react-router';

/**
 * Uygulama bağlantısı (/k/<işletme>/…, APP_CHANNELS_PLAN N2): uygulama yüklüyse işletim sistemi bu adresi uygulamada açar;
 * yüklü değilse buraya düşer → aynı yol ve sorgu ile web üyelik sayfasına.
 */
export function AppLinkRedirect() {
  const { tenant = '', '*': rest = '' } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/${encodeURIComponent(tenant)}/${rest}${search}`} replace />;
}
